export const STATES = ["Fortaleza", "São Paulo", "Recife", "Salvador", "Manaus"];
